export default "__VITE_ASSET__jjyg0m3D__"